module.exports = __webpack_public_path__ + "static/media/service-center-perawatan-berkala.a475c861.jpg";